const modal_config_store = {
    subscribers:{},
    options:{
        station_ids: []
    },
    setStationIds(ids){
        this.options.station_ids = ids
        this.publish('SET_STATION_IDS', ids)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default modal_config_store